// (c) 2022 Behaviour Interactive Inc. All rights reserved.

export enum ProviderNames {
  STEAM = 'steam',
  EGS = 'egs',
  STADIA = 'stadia',
}
